<div class="snackbar_container show_{{ showSnackbar }} type_{{ type }}">
  <div class="wrapper row">
    <rr-icon class="first" [name]="iconName"></rr-icon>
    <div class="col contentcol">
      <span class="snackbar_headline">{{ snackbarHeadline }}</span>
      <span class="snackbar_message">{{ snakbarContent }}</span>
    </div>
    <rr-icon class="close" name="close" (click)="close()"></rr-icon>
  </div>
</div>
